import React from 'react';
import { Chip } from '@mui/material';
import { tokens } from '../../theme/theme';

const LABELS = {
  draft: 'Draft',
  sent: 'Sent',
  in_progress: 'In Progress',
  partially_complete: 'Partial',
  complete: 'Complete',
  overdue: 'Overdue',
  cancelled: 'Cancelled',
};

function pillSx(status) {
  const c = tokens.color;
  switch (status) {
    case 'draft':
      return { color: c.ink3, bgcolor: c.surface, borderColor: c.border };
    case 'sent':
    case 'in_progress':
      return { color: c.info, bgcolor: c.infoBg, borderColor: 'transparent' };
    case 'partially_complete':
      return { color: c.warning, bgcolor: c.warningBg, borderColor: 'transparent' };
    case 'complete':
      return { color: c.success, bgcolor: c.successBg, borderColor: 'transparent' };
    case 'overdue':
      return { color: c.danger, bgcolor: c.dangerBg, borderColor: 'transparent' };
    case 'cancelled':
      return { color: c.ink3, bgcolor: c.surface, borderColor: c.border };
    default:
      return { color: c.ink3, bgcolor: c.surface, borderColor: c.border };
  }
}

export default function StatusPill({ status, size = 'small' }) {
  const label = LABELS[status] || status || '—';
  const sx = {
    ...pillSx(status),
    fontWeight: 600,
    borderStyle: 'solid',
    borderWidth: 1,
    '& .MuiChip-label': { px: 1 },
  };
  return (
    <Chip
      label={label}
      size={size}
      variant="outlined"
      sx={sx}
      component="span"
    />
  );
}
